import { useEffect } from 'react';

import { getFavorites } from '~/actions/favoriteActions';
import { useUserContext } from '~/contexts/UserContext';
import { useAppDispatch, useAppSelector } from '~/reducers';
import {
  getFavoritePhotoBoardUuid,
  getFavoritePhotosLoaded,
  getFavoriteStorefrontsLoaded,
  getFavoriteStorefrontEntity,
} from '~/selectors/favoritesSelectors';

/** We only need to get the data once: this global helps with that.  Keep that state in redux does not work because redux is not synchronous */
let useFavoritesRecentlyFetched = false;

/** A fetcher for favorite photos that runs just once */
const useFavorites = () => {
  const userContext = useUserContext();
  const { is_guest: isGuest } = userContext || {};

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (userContext && !isGuest && !useFavoritesRecentlyFetched) {
      useFavoritesRecentlyFetched = true;
      dispatch(getFavorites());
    }
  }, [dispatch, isGuest, userContext]);

  return {
    favoritePhotoBoardUuid: useAppSelector(getFavoritePhotoBoardUuid),
    photosLoaded: useAppSelector(getFavoritePhotosLoaded),
    storefrontsLoaded: useAppSelector(getFavoriteStorefrontsLoaded),
    storefrontFavoritesCount: useAppSelector(getFavoriteStorefrontEntity)?.allIds?.length || 0,
    isGuest,
  };
};

export default useFavorites;
